import type { Integration } from '@/types/Models/Integration'

export default class IntegrationsTransformer {
  /**
   * Method used to transform a fetched account.
   */
  static fetch(data: any): Integration {
    return { ...data } as Integration
  }

  /**
   * Method used to transform a fetched collection.
   */
  static fetchCollection(items: Integration[]) {
    return items.map((item: Integration) => this.fetch(item))
  }
}
